import { render, staticRenderFns } from "./OrganizeInfo.vue?vue&type=template&id=8b51d684&scoped=true&"
import script from "./OrganizeInfo.vue?vue&type=script&lang=js&"
export * from "./OrganizeInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeInfo.vue?vue&type=style&index=0&id=8b51d684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b51d684",
  null
  
)

export default component.exports